import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";

//POST /inventory/findSIM
//SIM库存管理列表
export function findSIM(page,params){
  return http.postJSON("/inventory/findSIM?"+jsonToFormData(page),params);
}
//POST /inventory/importXlxSIM
export function importXlxSIM(operatorName,file) {
 return http.postFormData("/inventory/importXlxSIM",{file:file,operatorName:operatorName})
}




// WEBPACK FOOTER //
// ./src/services/inventory.js